import React from "react";
import { Chip } from "@mui/material";
import { isDepartedMember, memberFullName } from "./helper";

// Member name as shown in grids and report tables. Members who have left the
// group keep their historical records, so the marker is what tells a reader
// that the name belongs to someone no longer in the network.
//
// Grid columns are narrow: the name truncates before the marker does, so the
// marker stays readable at any column width.
const MemberNameCell = ({ member }) => {
  if (!member) return null;

  const fullName = memberFullName(member);

  return (
    <span
      title={fullName}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        minWidth: 0,
        maxWidth: "100%",
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {fullName}
      </span>
      {isDepartedMember(member) && (
        <Chip
          label="Departed"
          size="small"
          variant="outlined"
          sx={{
            flexShrink: 0,
            height: "20px",
            fontSize: "11px",
            color: "#6B7280",
            borderColor: "#D1D5DB",
          }}
        />
      )}
    </span>
  );
};

export default MemberNameCell;
